// src/utils/notifications.js
import { toast } from "sonner";
import i18n from "../i18n";

// يدعم message كـ string أو string[]
export function notify(message, type = "success", options = {}) {
  const msgs = Array.isArray(message) ? message : [message];
  const safeMsgs = msgs.map((m) => String(m ?? "").trim()).filter(Boolean);
  if (safeMsgs.length === 0) return;

  const { description, duration, action } = options;
  const fire = type === "error" ? toast.error : toast.success;

  // ترجمة عبر المفاتيح إن وجدت داخل errors
  const t = i18n.t.bind(i18n);

  safeMsgs.forEach((m) => {
    const key = `errors.${m}`;
    const translated = t(key);
    const finalMsg = translated === key ? m : translated;
    fire(finalMsg, { description, duration, action });
  });
}

export default notify;
